/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-21 23:51:19
 * @FilePath: \hippo-web-admin\src\config\menus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  user: [
    {
      title: 'Status Overview',
      path: '/home',
      key: 'home',
      icon: 'custom-home',
      component: '/cgm/overview/index'
    },
    {
      title: 'Session Report',
      path: '/sessionReport',
      key: 'sessionReport',
      icon: 'custom-report',
      component: '/cgm/sessionReport/index'
    },
    {
      title: 'Glucose Report',
      path: '/report',
      key: 'glucoseReport',
      icon: 'custom-blood',
      component: '/cgm/glucoseReport/index'
    },
    {
      title: 'Follower List',
      path: '/follower',
      key: 'followerList',
      icon: 'custom-follow',
      component: '/cgm/follower/index'
    },
    // {
    //   title: 'Alert Settings',
    //   path: '/setting',
    //   key:'settings',
    //   icon: 'el-icon-setting',
    //   component: '/cgm/setting/index'
    // },
    {
      title: 'Profile',
      path: '/user/profile',
      hide: true,
      key: 'profile',
      component: '/user/profile'
    }
  ],
  follower: [
    {
      title: 'Home',
      path: '/home',
      icon: 'el-icon-house',
      key: 'home',
      hide: true,
      component: '/doctor/home/index'
    }
  ],
  cgm: [
    {
      title: 'Follow',
      path: '/follow',
      key: 'followerList',
      icon: 'el-icon-collection-tag',
      component: '/cgm/follower/index'
    }
  ]
};
